import React, { Component } from "react";
import { Link } from "react-router-dom";
import CountUp from "react-countup";
import VisibilitySensor from "react-visibility-sensor";
import "animate.css";

import Navbar from "../../Navbar/Navbar";
import MainBodyContainer from "../../Common/Body/MainBodyContainer/MainBodyContainer";
import Footer from "../../Footer/Footer";
import { AboutAPTData } from "../../Data/AboutAPTData";
import GroupCelebrationImage from "../../../images/people/events/thank-you-board.jpg";

import "./Mission.css";

class Mission extends Component {
  communityStats = [
    {
      figure: "750",
      suffix: "+",
      description: "Community Members Reached",
    },
    {
      figure: "200",
      suffix: "+",
      description: "Active Participants",
    },
    {
      figure: "100",
      suffix: "+",
      description: "Qualifications Achieved",
    },
    {
      figure: "16",
      suffix: "",
      description: "Into Employment (2024-25)",
    },
    {
      figure: "170",
      suffix: "+",
      description: "Advocacy Cases Supported",
    },
    {
      figure: "5",
      suffix: "",
      description: "East London Boroughs Served",
    },
  ];

  render() {
    const { mission } = AboutAPTData;

    return (
      <div>
        <Navbar />
        <div>
          <MainBodyContainer heading={"Our Mission & Values"}>
            {/* Hero Section */}
            <div className="two-column-container">
              <div className="left-column">
                <h1 className="animate__animated animate__fadeInUp">
                  EMPOWERING COMMUNITIES
                </h1>
                <h1 className="animate__animated animate__fadeInUp stylised-text">
                  ACROSS EAST LONDON
                </h1>
                <p className="mission-tagline animate__animated animate__fadeInUp">
                  {mission.tagline}
                </p>
                <p className="mission-statement animate__animated animate__fadeInUp">
                  {mission.missionStatement}
                </p>
              </div>
              <div className="right-column">
                <div>
                  <img 
                    src={GroupCelebrationImage}
                    alt="APT community celebration - empowering women and families across East London"
                  />
                </div>
              </div>
            </div>

            {/* Our Story Section */}
            <div className="body-section-container story-section">
              <div className="story-layout">
                <div className="story-left">
                  <h2 className="section-header">Our Story</h2>
                  <div className="story-highlight">
                    <div className="highlight-year">Founded in 2013.</div>
                    <p className="highlight-text">
                      Founded in 2013 by Emi Gjoni, Alisar Prospects Training emerged from a 
                      deep commitment to addressing educational and employment barriers facing 
                      London's most marginalized communities.
                    </p>
                    <p className="highlight-text">
                      What began as small-scale skills training has evolved into a holistic 
                      community organization supporting hundreds of individuals and families annually.
                    </p>
                  </div>
                </div>
                <div className="story-right">
                  <div className="founder-message">
                    <h3 className="founder-header">A Message from our Founder</h3>
                    <p className="founder-text">
                      "I founded APT because I saw talented, resilient people being locked out of 
                      opportunities by systems that didn't see them. Our job is to open those doors 
                      and walk through with them."
                    </p>
                    <div className="founder-signature">
                      <span className="founder-name">Emi Gjoni</span>
                      <span className="founder-title">Founder & Director</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            {/* Four Pillar Approach */}
            <div className="body-section-container four-pillars-section">
              <div className="section-intro">
                <h2 className="section-header">Our Four-Pillar Approach</h2>
                <p className="section-description">
                  We don't just deliver courses - we provide holistic support that addresses the real barriers
                  our community members face. Our approach recognizes that education, employment, advocacy, and
                  community belonging are interconnected.
                </p>
              </div>

              <div className="pillars-grid">
                {mission.fourPillarApproach.map((pillar, index) => (
                  <div key={`pillar-${index}`} className="pillar-card">
                    <div className="pillar-number">{index + 1}</div>
                    <h3 className="pillar-title">{pillar.pillar}</h3>
                    <p className="pillar-description">{pillar.description}</p>
                    <ul className="pillar-examples">
                      {pillar.examples.map((example, i) => (
                        <li key={`example-${index}-${i}`}>{example}</li>
                      ))}
                    </ul>
                  </div>
                ))}
              </div>
            </div>

            {/* Core Values Section */}
            <div className="body-section-container">
              <div className="body-row">
                <div className="body-column">
                  <h2 className="section-header left-align">Our Values</h2>
                  <p>These values guide everything we do at APT:</p>
                </div>
                <div className="body-column">
                  <div className="values-content">
                    {mission.coreValues.map((value, index) => (
                      <div key={`value-${index}`} className="value-item">
                        <h3 className="highlight">{value.value}</h3>
                        <p>{value.description}</p>
                      </div>
                    ))}
                  </div>
                </div>
              </div>

              {/* Operational Transparency Section */}
              <div className="body-section-container transparency-section">
                <div className="section-intro">
                  <h2 className="section-header">Transparency & Accountability</h2>
                </div>
                <div className="transparency-content">
                  <p>
                    <strong>Legal Status:</strong> {mission.operationalTransparency.legalStatus}
                  </p>
                  <p>
                    <strong>Governance:</strong> {mission.operationalTransparency.governance}
                  </p>
                  <p>
                    <strong>Annual Income:</strong> {mission.operationalTransparency.annualIncome}
                  </p>
                  <p className="financial-principle">
                    "{mission.operationalTransparency.financialPrinciple}"
                  </p>
                  <div className="funding-sources">
                    <h4>Funding Sources</h4>
                    <ul>
                      {mission.operationalTransparency.fundingSources.map((source, index) => (
                        <li key={`funding-${index}`}>{source}</li>
                      ))}
                    </ul>
                  </div>
                </div>
              </div>

              {/* Community Impact Stats */}
              <div className="impact-stats-section">
                <div className="stats-header">
                  <h2 className="section-header">Our Impact in Numbers (2024-25)</h2>
                  <p className="stats-intro">
                    These numbers represent real people - mothers, fathers, young people, and families
                    across London who we've supported on their journeys.
                  </p>
                </div>
                <div className="stats-grid">
                  {this.communityStats.map((stat, index) => (
                    <div key={`stat-${index}`} className="stat-card">
                      <VisibilitySensor partialVisibility offset={{ bottom: 20 }}>
                        {({ isVisible }) => (
                          <div className="stat-number">
                            {isVisible ? (
                              <>
                                <CountUp end={parseInt(stat.figure)} duration={2.5} />
                                {stat.suffix}
                              </>
                            ) : null}
                          </div>
                        )}
                      </VisibilitySensor>
                      <div className="stat-label">{stat.description}</div>
                      <div className="stat-decoration"></div>
                    </div>
                  ))}
                </div>
              </div>

              {/* Call to Action */}
              <div className="cta-section">
                <h2>Join Us in Building Stronger Communities</h2>
                <p>
                  Whether you're seeking support, want to volunteer, or are interested in partnering with us, 
                  we welcome you to be part of APT's community empowerment work.
                </p>
                <div className="cta-buttons">
                  <Link to="/get-involved/volunteer" className="cta-button secondary">
                    Volunteer With Us
                  </Link>
                  <Link to="/about/partnerships" className="cta-button secondary">
                    Partner With APT
                  </Link>
                </div>
              </div>
            </div>
          </MainBodyContainer>
        </div>
        <Footer />
      </div>
    );
  }
}

export default Mission;